<footer class="footer-container">
    <div class="footer">
        <div class="categories">
            <div class="categories--logo">
                <div class="logo">
                    <img src="/assets/images/logo.png" loading="lazy" alt="" srcset="" />
                </div>

                <div class="flex items-center gap-[6.36px]">
                    <div
                        class="flex h-10 w-[116px] items-center justify-center rounded-md border-[0.725px] border-primary-200 bg-white pb-[1px]"
                    >
                        <img src="/assets/images/gov.png" loading="lazy" alt="" srcset="" />
                    </div>
                    <div
                        class="flex h-10 w-[60px] items-center justify-center rounded-md border-[0.725px] border-primary-200 bg-white px-2 py-[5px]"
                    >
                        <img
                            src="/assets/images/home/partner-logo/iata.png"
                            loading="lazy"
                            alt=""
                            srcset=""
                        />
                    </div>
                </div>

                <ul class="social-network !hidden">
                    <li>
                        <a href="https://www.facebook.com/vemaybayphuongnam">
                            <svg-icon src="/assets/icons/akar-icons_facebook-fill.svg" />
                        </a>
                    </li>
                    <li hidden>
                        <a href="#">
                            <svg-icon src="/assets/icons/akar-icons_twitter-fill.svg" />
                        </a>
                    </li>
                    <li hidden>
                        <a href="#">
                            <svg-icon src="/assets/icons/akar-icons_youtube-fill.svg" />
                        </a>
                    </li>
                    <li hidden>
                        <a href="#">
                            <svg-icon src="/assets/icons/ant-design_instagram-filled.svg" />
                        </a>
                    </li>
                </ul>
            </div>

            <div class="categories--list">
                <div class="category !hidden">
                    <div class="category-title">
                        <h3 i18n="@@footer.product">SẢN PHẨM</h3>
                        <button (click)="expanded = expanded === 1 ? 0 : 1">
                            <svg-icon
                                src="/assets/icons/chevron-down.svg"
                                [svgClass]="[
                                    'size-6',
                                    'transition-all',
                                    'duration-300',
                                    expanded === 1 ? 'rotate-180' : '',
                                ]"
                                class="icon:fill-neutral-01"
                            />
                        </button>
                    </div>
                    <ul [@expandState]="expanded === 1 ? 'expanded' : 'collapsed'">
                        <li i18n="@@footer.product.flight-ticket">Vé máy bay</li>
                        <li i18n="@@footer.product.hotel">Khách sạn</li>
                        <li i18n="@@footer.product.combo">Combo tiết kiệm</li>
                        <li i18n="@@footer.product.airport-transfer">Đưa đón sân bay</li>
                    </ul>
                </div>
                <div class="category">
                    <div class="category-title">
                        <h3 i18n="@@footer.about-us">VỀ CHÚNG TÔI</h3>
                        <button (click)="expanded = expanded === 2 ? 0 : 2">
                            <svg-icon
                                src="/assets/icons/chevron-down.svg"
                                [svgClass]="[
                                    'size-6',
                                    'transition-all',
                                    'duration-300',
                                    expanded === 2 ? 'rotate-180' : '',
                                ]"
                                class="icon:fill-neutral-01"
                            />
                        </button>
                    </div>
                    <ul [@expandState]="expanded === 2 ? 'expanded' : 'collapsed'">
                        <li>
                            <a routerLink="/contact-us" i18n="@@footer.about-us.contact-us">
                                Liên hệ
                            </a>
                        </li>
                        <li>
                            <a routerLink="/about-us" i18n="@@footer.about-us.introduce">
                                Giới thiệu
                            </a>
                        </li>
                        <li>
                            <a
                                routerLink="/terms-and-conditions"
                                i18n="@@footer.about-us.terms-of-use"
                            >
                                Điều khoản sử dụng
                            </a>
                        </li>
                        <li>
                            <a routerLink="/policy" i18n="@@footer.about-us.privacy-policy">
                                Chính sách bảo mật
                            </a>
                        </li>
                        <li i18n="@@footer.about-us.business-license" hidden>
                            Giấy phép kinh doanh
                        </li>
                    </ul>
                </div>
                <div class="category">
                    <div class="category-title">
                        <h3 i18n="@@footer.you-need-know">BẠN CẦN BIẾT</h3>
                        <button (click)="expanded = expanded === 3 ? 0 : 3">
                            <svg-icon
                                src="/assets/icons/chevron-down.svg"
                                [svgClass]="[
                                    'size-6',
                                    'transition-all',
                                    'duration-300',
                                    expanded === 3 ? 'rotate-180' : '',
                                ]"
                                class="icon:fill-neutral-01"
                            />
                        </button>
                    </div>
                    <ul [@expandState]="expanded === 3 ? 'expanded' : 'collapsed'">
                        <li>
                            <a routerLink="/how-to-pay" i18n="@@footer.you-need-know.how-to-pay">
                                Hướng dẫn thanh toán
                            </a>
                        </li>
                        <!-- <li i18n="@@footer.you-need-know.sales-policy">Chính sách bán hàng</li>
                        <li i18n="@@footer.you-need-know.wire-transfer-info">
                            Thông tin chuyển khoản
                        </li> -->
                        <li>
                            <a routerLink="/how-to-book" i18n="@@footer.you-need-know.how-to-book">
                                Hướng dẫn đặt vé
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="category">
                    <div class="category-title">
                        <h3 i18n="@@footer.contact">THÔNG TIN LIÊN HỆ</h3>
                        <button (click)="expanded = expanded === 4 ? 0 : 4">
                            <svg-icon
                                src="/assets/icons/chevron-down.svg"
                                [svgClass]="[
                                    'size-6',
                                    'transition-all',
                                    'duration-300',
                                    expanded === 4 ? 'rotate-180' : '',
                                ]"
                                class="icon:fill-neutral-01"
                            />
                        </button>
                    </div>
                    <ul [@expandState]="expanded === 4 ? 'expanded' : 'collapsed'">
                        <li i18n="@@footer.contact.company-name">
                            CÔNG TY TNHH DV DL NGÔI NHÀ PHƯƠNG NAM
                        </li>
                        <li>
                            <a
                                href="https://maps.app.goo.gl/nGZo8L1HT7Kf2xYcA"
                                target="_blank"
                                i18n="@@footer.contact.address-1"
                            >
                                987 Phạm Văn Bạch, Phường An Hội Tây, TP.Hồ Chí Minh
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://maps.app.goo.gl/pv97MP1hDjnD3Rvj6"
                                i18n="@@footer.contact.address-2"
                            >
                                60 Khúc Thừa Dụ, Phường Cầu Giấy, TP.Hà Nội
                            </a>
                        </li>
                        @if (commonConfig.email; as email) {
                            <li>
                                Email:
                                <a [attr.href]="'mailto:' + email">
                                    {{ email }}
                                </a>
                            </li>
                        }
                        @if (commonConfig.hotline; as hotline) {
                            <li>
                                Hotline:
                                <a [attr.href]="'tel:' + hotline">{{ hotline }}</a>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        </div>

        <div class="copyright mb:!flex-col mb:!items-start mb:gap-2">
            <p class="font-lato text-sm text-neutral-01">
                © Copyright {{ commonConfig.copyright.owner }} {{ commonConfig.copyright.year }}
            </p>
            <div class="payment-method">
                <svg-icon src="/assets/icons/method-visa.svg" />
                <svg-icon src="/assets/icons/method-mastercard.svg" />
                <svg-icon
                    class="rounded border border-neutral-03 bg-neutral-01 px-1"
                    svgClass="!h-[28px]"
                    src="/assets/icons/method-napas.svg"
                />
                <svg-icon hidden src="/assets/icons/method-googlepay.svg" />
                <svg-icon hidden src="/assets/icons/method-paypal.svg" />
                <svg-icon hidden src="/assets/icons/method-applepay.svg" />
            </div>
        </div>
    </div>
</footer>
